import React from 'react';

import HoneyPot from 'common/Form/components/HoneyPot';

import Name from './components/Name';
import Contact from './components/Contact';
import Civility from './components/Civility';

/**
 * @typedef {{
 *  defaultCountry?: string,
 * }} CustomerInputsProps
 */

/** @type {React.FC<CustomerInputsProps>} */
const CustomerInputs = ({ defaultCountry }) => (
  <>
    <Civility />
    <Name />
    <Contact defaultCountry={defaultCountry} />
    <HoneyPot />
  </>
);

export default CustomerInputs;
